import styled from "styled-components";
import GridCardComponent from "./generic/GridCardComponent";
import { formatDefaultDateTime, formatPrice } from "../../../utils/Formatter";
import { defaultStatusColors, getSpanWithColor } from "../../../utils/CardUtils";
import { TooltipReorderCard } from "../../pages/orders/reordersComponents/ReordersTooltips";
import noImage2 from "../../../assets/images/no-image.png";

// #region SCOPED CSS
const StyledPage = styled.div`
    &.empty-card .right-card-image,
    .Frame-340 > .left-card-image {
        padding: 10px !important;
    }

    .Frame-340 > .Image-5 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
        box-sizing: border-box !important;
    }

    .Frame-161 {
        margin-bottom: 4px !important;
    }

    .Frame-161-secondary {
        margin-bottom: 4px !important;
    }
`;
// #endregion

export default function ReordersGridCard(props) {
    //CONSTANTS & CONFIG
    const ALLOW_INTERNAL_TRANSFERS = false;

    const {
        emptyCard = false,
        className = "",
        primaryButtonOnClick = undefined,
        secondaryButtonOnClick = undefined,
        thirdButtonOnClick = undefined
    } = props || {};

    const {
        _id = "--",
        reorderNumber = "--",
        styleCode = "--",
        styleName = "--",
        labelBrandName = "--",
        labelBrandLogo = "--",
        //totalItems = "--",
        status = "--",
        firstGeneratedDate = "--",
        images = [],
        storeName = "--",
        season = "--",
        portentialTurnover = "--",
        daysToEndOfLifecycle = "--",
        highestPriority = "--",
        sentByUserName = "--",
        totalProvisionalQuantityNeeded = "--"
    } = props?.data || {};

    //COMPUTED VARS
    const statusLabelTxt = status === "Shared" ? "Sent" : status === "DeclinedByRetailBrand" ? "Declined" : status;
    const isBorderHighlighted = status === "New";
    const borderHighlightColor = status === "New" ? "#0b0" : "";
    const isSendButtonEnabled = false; //TODO: FOR LATER: primaryButtonOnClick && !emptyCard && status?.toLowerCase() === "new";
    const isViewButtonEnabled = secondaryButtonOnClick && !emptyCard && status?.toLowerCase() === "new";
    const isMetricsButtonEnabled = !emptyCard;

    return (
        <StyledPage className={`${className || ""} ${emptyCard ? "empty-card" : ""}`}>
            <GridCardComponent
                key={_id}
                // IMAGE
                image={labelBrandLogo}
                image2={emptyCard ? noImage2 : images?.[0]?.URL}
                imageBorderRadius={"0px"}
                imageFit="contain"
                image2Fit={emptyCard ? "contain" : "cover"}
                imageHasPadding={false}
                // TOP
                titlePrefix={"STYLE CODE:"}
                title={styleCode}
                secondaryTitlePrefix={"STYLE NAME:"}
                secondaryTitle={styleName}
                idPrefix={"REORDER NR:"}
                id={reorderNumber}
                // FIELDS
                noOfRows={12}
                details={[
                    { key: "From store:", value: storeName || "--" },
                    { key: "To brand:", value: labelBrandName || "--" },
                    { isSeparator: true },
                    { key: "Season:", value: season || "--" },
                    { key: "Calculated need:", value: totalProvisionalQuantityNeeded ?? "--" },
                    { key: "Days to end lifecycle:", value: daysToEndOfLifecycle ?? "--" },
                    { key: "Highest priority:", value: highestPriority || "--" },
                    { key: "Potential turnover:", value: formatPrice(portentialTurnover, "kr", "--", false, 2) },
                    { isSeparator: true },
                    { key: "First generated on:", value: formatDefaultDateTime(firstGeneratedDate) },
                    { key: "Sent by:", value: sentByUserName ?? "--" },
                    { key: "Status:", value: getSpanWithColor(statusLabelTxt, defaultStatusColors) }
                ]}
                // CARD LOGIC
                isCardEnabled={!emptyCard && status?.toLowerCase() !== "suspended"}
                isCardSuspended={status?.toLowerCase() === "suspended"}
                highlighted={isBorderHighlighted}
                highlightColor={borderHighlightColor}
                highlightCustomText={status}
                cardData={props?.data}
                // BUTTONS
                edit={{ hidden: true }}
                suspend={{ hidden: true }}
                delete={{ hidden: true }}
                primaryButton={{
                    title: "Send",
                    onClick: isSendButtonEnabled ? () => primaryButtonOnClick(props?.data) : undefined
                }}
                secondaryButton={{
                    title: "View",
                    onClick: isViewButtonEnabled ? () => secondaryButtonOnClick(props?.data) : undefined
                }}
                thirdButton={{
                    title: "METRICS",
                    onClick: isMetricsButtonEnabled ? () => thirdButtonOnClick(props?.data) : undefined
                }}
                showSelections={true}
                rightTooltip={{
                    disabled: emptyCard,
                    content: <TooltipReorderCard data={props?.data} hasInternalTransfer={ALLOW_INTERNAL_TRANSFERS} />,
                    width: "255px"
                }}
            />
        </StyledPage>
    );
}
